<template>
    <div>
        <div class="relative px-6 pt-3"
            :class="{'pb-10': isError,'pb-3': !isError}">
            <div class="border border-a-gray-aaaaaa rounded-40 grid grid-cols-3 px-5 py-3"
                :class="{'border-a-red-ca2121': isError, 'bg-a-gray-eeeeee text-a-gray-cccccc border border-a-gray-cccccc': disabled}">
                <input
                    class="w-full text-26  text-center col-start-2 row-start-1 my-auto font-Medium"
                    v-model="content"
                    :placeholder="inputLbl.placeholder"
                    :maxlength="inputMaxLength"
                    :disabled="disabled"
                    @blur="onInputKeyUp()"
                    @focus="onInputFocus()"
                    @input="onChange()"
                    >
                    <div class="text-18 text-right text-a-gray-666666 col-start-3 row-start-1 my-auto font-Text">
                    {{inputLbl.name}}
                </div>
            </div>
            <div class="text-a-red-ca2121 text-16 text-center absolute bottom-0 left-0 w-full text-left px-6 h-10" v-if="isError">
                <div>{{getErrorMsg}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import RegxHelper from "@/helper/RegxHelper.js";

/**
 * @property {String} v-model:inputValue (required) bind value
 * @property {Number} minLength (optional) Minimum length.
 * @property {Number} maxLength (optional) Maximum Length.
 * @property {Object} errorInfo (required) Validate result. example : { isValid: true, msg: '',}
 * @property {Boolean} isShowError (optional) Show/Hide Error label.
 * @property {Boolean} isSubmitted (optional) Show/Hide Error after save.
 * @property {Object} inputLbl (required) Text for component.
 */
export default {
    name: "InputNumber",
    props: {
        // v-model
        inputValue:     { type: [String, Number] },
        // props
        minLength:      { type: Number },
        maxLength:      { type: Number, default: 0 },
        errorInfo:      { type: Object, required: true },
        isShowError:    { type: Boolean, default: false },
        isSubmitted:    { type: Boolean, default: false },
        disabled:       { type: Boolean, default: false },
        // text
        inputLbl:       { type: Object, required: true },
        // Custom
        enableFocusCheck : { type: Boolean, default: false},
        showDefaultValue: { type: [Number, String], required: false},
    },
    data: function() {
        return {
            content: this.inputValue,
            inputMaxLength: null,
            state: null,
        };
    },
    computed: {
        isError: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid);
        },
        getErrorMsg: function() {
            return (this.isShowError && this.isSubmitted && !this.errorInfo.isValid)
                ? this.errorInfo.msg
                : '';
        }
    },
    created: function() {
        if(this.content == '' && this.showDefaultValue != null){
            this.content = this.showDefaultValue
        }

        if (this.maxLength > 0) {
            this.inputMaxLength = this.maxLength;
        }
    },
    mounted: function() {
        this.validateInput();
    },
    methods: {
        validateInput: function () {
            if (!this.inputLbl) {
                return;
            }
            if (isNaN(this.content)) {
                this.content = ''
                return;
            }
            
            // set default.
            this.errorInfo.setValid(true);
            this.errorInfo.setMsg('');
            // required
            if (this.inputLbl.required && !this.content) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(this.inputLbl.required)
                return;
            }
            // too short
            if (this.inputLbl.too_short && this.minLength
                && (this.content.length < this.minLength)) {
                this.errorInfo.setValid(false);
                this.errorInfo.setMsg(Util.stringFormat(this.inputLbl.too_short, this.minLength));
                return;
            }
        },
        onChange: function() {
            this.validateInput();
            this.checkNumber();
            if(this.enableFocusCheck){
                if(this.state == 'typing') return;
                    this.checkNumber();
                    this.validateInput();
                    this.$emit('update:inputValue', this.content);
            }else{
                this.checkNumber();
                this.validateInput();
                setTimeout(() => {
                    this.$emit('update:inputValue', this.content);
                }, 2000);
            }

        },

        onInputKeyUp: function(){
            this.state = null;
            this.onChange();
        },
        onInputFocus: function(){
            this.state = 'typing';
        },
        checkNumber: function() {
            let result = this.content;
            if (result != '')
                result = RegxHelper.removeNotNumber(result.toString());

            this.content = result;
            return this.content
        },
        onUpdatePoint: function(point) {
            this.content = point;
            this.validateInput();
        },
        onUpdateError: function(errMsg) {
            this.errorInfo.setValid(false);
            this.errorInfo.setMsg(errMsg)
        }
    },
}
</script>
<style lang="scss" scoped>
@import '../../style/base.scss';
.font-Medium {
    font-family: $ff-Medium;
}
.font-Text {
    font-family: $ff-text;
}
</style>
